// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logos[data-v-09571160]{align-items:center;display:flex;flex-wrap:wrap;margin:-.75rem -1rem}.logos.narrow[data-v-09571160]{margin:-.5rem}@media (min-width:1024px){.logos.narrow[data-v-09571160]{margin:-.75rem -1rem}}.logos.narrow .logos__item[data-v-09571160]{padding:.5rem}@media (min-width:1024px){.logos.narrow .logos__item[data-v-09571160]{padding:.75rem 1rem}}.logos__item[data-v-09571160]{padding:.75rem 1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
